// Hub is single-tone premium (black + gold). Always render the
// dark-bg-optimized logo (white + gold wordmark) regardless of the
// `theme` argument so the SK Kapoor mark stays sharp on the black surface.
export const LOGO_LIGHT =
  "https://customer-assets.emergentagent.com/job_ai-command-center-139/artifacts/2b0ws9af_SK%20Dark%20BG.png";
export const LOGO_DARK =
  "https://customer-assets.emergentagent.com/job_ai-command-center-139/artifacts/2b0ws9af_SK%20Dark%20BG.png";

export function logoFor(_theme) {
  return LOGO_DARK;
}
